(ns frontend.device-id
  (:require [frontend.local-storage :as ls]
            [cljs-uuid-utils.core :as uuid]))

(defn device-id []
  (ls/get :device-id))

(defn init! []
  (when-not (device-id)
    (->> (uuid/make-random-uuid)
         (uuid/uuid-string)
         (ls/set :device-id))))

